import axios from "axios";

// Used for testing vs non testing purposes
const csrfToken =
  typeof document !== "undefined"
    ? document.querySelector('meta[name="csrf-token"]')?.getAttribute("content")
    : null;

export const api = axios.create({
  baseURL: "/api",
  timeout: 30000, // 30 seconds timeout for all requests
  headers: {
    ...(csrfToken && { "X-CSRF-TOKEN": csrfToken }),
  },
});

export const isApiError = axios.isAxiosError;
